class Video {
    static videos = document.querySelectorAll('[data-module="video"], [data-module="video-element"]')
    static timestamps = document.querySelectorAll('[data-video-timestamp]')

    static init () {
        if (!this.videos) return

        this.addEventListeners()
    }

    static addEventListeners () {
        this.playButton()
        this.playFromTimestamp()
    }

    static playButton () {
        this.videos.forEach(video => {
            const playButton = video.querySelector('[data-video-play-button]')
            const isVideoElement = video.hasAttribute('data-module') && video.getAttribute('data-module') === 'video-element'

            if (!playButton) return

            playButton.addEventListener('click', () => {
                if (isVideoElement) {
                    video.classList.add(('is-playing'))
                    video.querySelector('video').play()
                    video.querySelector('video').setAttribute('controls', '')
                } else {
                    this.addIframe(video)
                }
            })
        })
    }

    static playFromTimestamp () {
        if (!this.timestamps) return

        this.timestamps.forEach(timestamp => {
            timestamp.addEventListener('click', () => {
                const video = document.querySelector(`${timestamp.getAttribute('href')} [data-module="video"]`)
                const time = this.convertTimeToSeconds(timestamp.dataset.videoTimestamp)
                this.addIframe(video, 1, time)
            })
        })
    }

    static addIframe (container, autoplay = 1, timestamp = 0) {
        if (!container) return

        const src = container.dataset.videoSrc

        if (!src) return

        const iframe = document.createElement('iframe')
        iframe.className = 'absolute top-0 left-0 h-full w-full'
        iframe.width = '100%'
        iframe.height = 'auto'
        iframe.src = `${src}?autoplay=${autoplay}&start=${timestamp}`
        iframe.allow = 'autoplay'
        iframe.frameBorder = '0'
        iframe.allowFullscreen = true
        iframe.referrerPolicy = 'strict-origin-when-cross-origin'
        iframe.setAttribute('data-cmp-ab', '2')

        container.innerHTML = ''
        container.appendChild(iframe)
    }

    static convertTimeToSeconds (time) {
        if (!time) return

        time = time.split(':')
        let seconds = parseInt(time[2])

        // Add hours to seconds
        seconds = seconds + (parseInt(time[0]) * 3600)

        // Add minutes to seconds
        seconds = seconds + (parseInt(time[1]) * 60)

        return seconds
    }
}

export default (function () {
    Video.init()
})
